import * as React from 'react'

import { CoverageCalculator } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  CoverageCalculator as CoverageCalculatorWidget,
  CoverageCalculatorProps,
} from '@thg-commerce/enterprise-widget-coverage-calculator'
import { mq, spacing, styled } from '@thg-commerce/gravity-theme'

import { BaseWidgetProps } from '../types'

export type CoverageCalculatorRendererProps = BaseWidgetProps &
  Omit<CoverageCalculator, 'query'>

const StyledCoverageCalculator = styled(CoverageCalculatorWidget)`
  margin: ${spacing(5)} auto ${spacing(6)};
  max-width: ${(props) => props.theme.site.siteWidth};
  padding: 0 ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: 0 ${spacing(4.5)};
  }
`

export const CoverageCalculatorRenderer = (
  props: CoverageCalculatorRendererProps,
) => {
  const coverageCalculatorProps: CoverageCalculatorProps = {
    title: { text: props.calculatorTitle || undefined },
    subtitle: props.calculatorSubtitle || undefined,
    additionalInfoTitle: props.additionalInfoTitle || undefined,
    additionalInfoText:
      props.additionalInfoText?.content[0]?.content || undefined,
    instructionsTitle: props.instructionsTitle || undefined,
    instructionsText: props.instructionsText?.content[0]?.content || undefined,
    paintCoverage: Number(props.paintCoverage) || undefined,
    buyButtonUrl: props.buyButtonLink || undefined,
  }

  return <StyledCoverageCalculator {...coverageCalculatorProps} />
}
